import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed } from "@preact/signals"
import { createLogger } from "@/utils/logger"

const logger = createLogger("")

async function fetchAccounts() {
    await ApiSignalFetchers.fetchDataSignalAccounts()
}

const accounts = computed(() => {
    return ApiSignals.dataSignalFetchAccounts.value?.list
})

export { fetchAccounts, accounts }
